// src/utils/appearancePreference.js

export const APPEARANCE_STORAGE_KEY =
  "app.appearance";

const VALID_APPEARANCES =
  new Set([
    "dark",
    "light",
    "system",
  ]);

export const getStoredAppearance =
  () => {
    const stored =
      localStorage.getItem(
        APPEARANCE_STORAGE_KEY
      );

    return VALID_APPEARANCES.has(
      stored
    )
      ? stored
      : "dark";
  };

export const resolveAppearance =
  (
    preference =
      getStoredAppearance()
  ) => {
    if (
      preference !==
      "system"
    ) {
      return preference;
    }

    if (
      typeof window ===
        "undefined" ||
      !window.matchMedia
    ) {
      return "dark";
    }

    return window.matchMedia(
      "(prefers-color-scheme: light)"
    ).matches
      ? "light"
      : "dark";
  };

export const applyAppearance =
  (
    preference
  ) => {
    const normalizedPreference =
      VALID_APPEARANCES.has(
        preference
      )
        ? preference
        : "dark";

    const resolved =
      resolveAppearance(
        normalizedPreference
      );

    document.documentElement.setAttribute(
      "data-theme",
      resolved
    );

    document.documentElement.style.colorScheme =
      resolved;

    window.dispatchEvent(
      new CustomEvent(
        "app:appearance:changed",
        {
          detail: {
            preference:
              normalizedPreference,

            resolved,
          },
        }
      )
    );

    return resolved;
  };

export const saveAppearance =
  (
    preference
  ) => {
    const normalizedPreference =
      VALID_APPEARANCES.has(
        preference
      )
        ? preference
        : "dark";

    localStorage.setItem(
      APPEARANCE_STORAGE_KEY,
      normalizedPreference
    );

    return applyAppearance(
      normalizedPreference
    );
  };

export const applyStoredAppearance =
  () =>
    applyAppearance(
      getStoredAppearance()
    );

export const bindSystemAppearanceListener =
  () => {
    if (
      typeof window ===
        "undefined" ||
      !window.matchMedia
    ) {
      return () => {};
    }

    const mediaQuery =
      window.matchMedia(
        "(prefers-color-scheme: light)"
      );

    const handleChange =
      () => {
        if (
          getStoredAppearance() ===
          "system"
        ) {
          applyAppearance(
            "system"
          );
        }
      };

    if (
      mediaQuery.addEventListener
    ) {
      mediaQuery.addEventListener(
        "change",
        handleChange
      );

      return () => {
        mediaQuery.removeEventListener(
          "change",
          handleChange
        );
      };
    }

    mediaQuery.addListener?.(
      handleChange
    );

    return () => {
      mediaQuery.removeListener?.(
        handleChange
      );
    };
  };